import { features } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择网红黑料网
          </h2>
          <p className="text-sm md:text-base text-foreground-500 font-body max-w-2xl mx-auto">
            五大核心优势，打造全网最专业的网红黑料聚合平台，让吃瓜更有品质
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group flex flex-col items-center text-center p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${feat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2.5">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 font-body leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}